import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import api from "../utils/api"

// Generic hook for GET requests
export const useApiQuery = (key, url, options = {}) => {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      // //console.log('Just before api.get ')
      const response = await api.get(url)
      // //console.log('response ', response.data)
      return response.data
    },
    ...options,
  })
}

// Generic hook for POST/PUT/DELETE requests
export const useApiMutation = (url, method = "POST", options = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data) => {
      const response = await api[method.toLowerCase()](url, data)
      return response.data
    },
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch queries after successful mutation
      if (options.invalidateQueries) {
        queryClient.invalidateQueries({
          queryKey:options.invalidateQueries,
          refetchType:"active",
        })
      }
      if (options.onSuccess) {
        options.onSuccess(data, variables, context)
      }
    },
    ...options,
  })
}

// Specific hooks for common operations
export const useClients = () => {
  return useApiQuery(["clients"], "/clients")
}

export const useJobs = () => {
  return useApiQuery(["jobs"], "/jobs")
}

export const useUsers = () => {
  return useApiQuery(["users"], "/users")
}

export const useCreateClient = () => {
  return useApiMutation("/clients", "POST", {
    invalidateQueries: ["clients"],
  })
}

export const useCreateJob = () => {
  return useApiMutation("/jobs", "POST", {
    invalidateQueries: ["jobs"],
  })
}

export const useCreateUser = () => {
  return useApiMutation("/users", "POST", {
    invalidateQueries: ["users"],
  })
}

export const useJobById = (jobId) => {
  return useApiQuery(['job'],`/jobs/${jobId}`)
}